/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Mon, Aug 16th 2021, 5:24:05 pm
 *
 * *****************************************************
 */

export const SIGN_IN_WITH_EMAIL_PASSWORD_RECAPTCHA_ACTION = 'sign_in_with_email_password';
export const SIGN_UP_WITH_EMAIL_PASSWORD_RECAPTCHA_ACTION = 'sign_up_with_email_password';
export const SIGN_IN_WITH_GOOGLE_RECAPTCHA_ACTION = 'sign_in_with_google';
export const SIGN_UP_WITH_GOOGLE_RECAPTCHA_ACTION = 'sign_up_with_google';
export const CREATE_WORKSPACE_RECAPTCHA_ACTION = 'create_workspace';
